import { ThemeContext, css } from '@emotion/react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { useUID } from 'react-uid';
import { useContext } from 'react';

import { AppTheme } from 'theme';

import { Button, Flex } from '..';
import Modal from '../Modal';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onContinue: () => void;
  onRestart: () => void;
}

const UnfinishedTutorialDialog = ({
  isOpen,
  onClose,
  onContinue,
  onRestart,
}: Props) => {
  const modalHeadingId = useUID();
  const [t] = useTranslation();

  const theme = useContext(ThemeContext) as AppTheme;
  const IS_EDU = theme?.layout?.edu;

  return (
    <Modal
      isOpen={isOpen}
      showClose={IS_EDU}
      onRequestClose={onClose}
      aria={{
        labelledby: modalHeadingId,
      }}
      css={css`
        .Overlay {
          z-index: 10;
        }
        .Modal {
          background-color: white;
          min-width: 350px;
        }
      `}
    >
      <Flex p={4} flexDirection="column" alignItems="center">
        <Text id={modalHeadingId} css={{ paddingInline: 10 }}>
          {t('unfinishedTutorial.text', 'Máte nedokončenou hru s průvodcem')}
        </Text>
        <Button
          extraWide
          variant={IS_EDU ? 'primary' : 'warning'}
          labelT={{
            key: 'unfinishedTutorial.continue',
            defaultValue: 'Pokračovat',
          }}
          onClick={onContinue}
        />
        <Button
          extraWide
          variant={IS_EDU ? 'outline-primary' : 'transparent'}
          css={{ marginTop: 10 }}
          labelT={{
            key: 'unfinishedTutorial.restart',
            defaultValue: 'Od začátku',
          }}
          onClick={onRestart}
        />
      </Flex>
    </Modal>
  );
};

export default UnfinishedTutorialDialog;

const Text = styled.p`
  color: black;
  text-align: center;
  line-height: 1.4;
  padding: 0;
  margin: 0;
  margin-bottom: 24px;
`;
